const uniqueId = () => Math.random().toString(36).slice(4);

export default uniqueId;



// WEBPACK FOOTER //
// ./src/shared-components/chipsautocomplete/uniqueId.js